export const URL_CONSULTA = process.env.REACT_APP_URL_CONSULTA;
export const URL_CHAT = process.env.REACT_APP_URL_CHAT;
